import React from "react"
import {useAccessToken} from "../../../../services/auth"
import useAsyncResultIdle from "../../../../hooks/useAsyncResultIdle"

import {Application, IndividualApplicationData, resubmitIndividualApplication} from "../../../../resources/application"
import ConfirmationModalContent from "../ConfirmationModalContent"

export default function ReevaluateIndividualApplicationConfirmationModal(props: {
	close: () => void
	onSuccess: () => void
	application: Application
	enableReevaluateApplication: boolean
	reevaluatedData: IndividualApplicationData
}) {
	const {close, onSuccess, application, enableReevaluateApplication, reevaluatedData} = props
	const accessToken = useAccessToken()
	const [updateIndividualRequest, setUpdateIndividualRequest] = useAsyncResultIdle(resubmitIndividualApplication)

	const handleSubmit = (reason: string) => {
		const data = {
			dob: reevaluatedData.dob,
			ssn: reevaluatedData.ssn,
			email: reevaluatedData.email,
			phone: reevaluatedData.phone,
			address: reevaluatedData.address,
			passport: reevaluatedData.passport,
			fullName: reevaluatedData.fullName,
			nationality: reevaluatedData.nationality,
			reasonText: reason,
			matriculaConsular: reevaluatedData.matriculaConsular,
			ein: reevaluatedData.ein || undefined, // we default undefined to not have the fields as part of the patch object.
			website: reevaluatedData.website || undefined, // we default undefined to not have the fields as part of the patch object.
		}

		setUpdateIndividualRequest(accessToken, application, data)
	}

	return (
		<ConfirmationModalContent
			state={updateIndividualRequest}
			close={close}
			onSubmit={handleSubmit}
			onSuccess={onSuccess}
			enableReevaluateApplication={enableReevaluateApplication}
		/>
	)
}
